import {Component, Input, OnInit} from '@angular/core';
import {CFASTLINKMAPPERFASTLINK, CFASTLINKMAPPERVELDSTATION} from "../fastlinkstruct";

@Component({
  selector: 'app-fast-link-veld-station',
  templateUrl: './fast-link-veld-station.component.html',
  styleUrls: ['./fast-link-veld-station.component.css']
})
export class FastLinkVeldStationComponent implements OnInit {
  @Input() veldStationRunTime: CFASTLINKMAPPERVELDSTATION | undefined;
  @Input() veldStationBluePrint: CFASTLINKMAPPERVELDSTATION | undefined;

  @Input() fastLinkListBluePrint: CFASTLINKMAPPERFASTLINK[] = Array();
  @Input() fastLinkListRunTime: CFASTLINKMAPPERFASTLINK[] = Array();
  constructor() { }


  Counter(i: number) {
    return new Array(i);
  }

  GetNewVeldStation() : boolean
  {
    if((this.veldStationBluePrint?.status  == 0) && (this.veldStationRunTime?.status  != 0) )
        return true;
    return false;
  }

  CompareStation(nummerVeldstation: number) : boolean
  {
    if (this.veldStationBluePrint && this.veldStationBluePrint.station == this.StationNr(nummerVeldstation))
      return true;
    return false;
  }

  FindBluePrint(station: number ) : CFASTLINKMAPPERFASTLINK | undefined
  {
    for(let fastLink of this.fastLinkListBluePrint)
    {
      if (this.CompareStation(fastLink.nummerVeldstation)) {
        if (fastLink.fastlinkstation == station) {
          return fastLink;
        }
      }
    }
    return undefined;
  }


  FindRunTime(station: number ) : CFASTLINKMAPPERFASTLINK | undefined
  {
      for(let fastLink of this.fastLinkListRunTime)
      {
          if( this.veldStationBluePrint && this.veldStationBluePrint.station == this.StationNr(fastLink.nummerVeldstation)) {
            if (fastLink.fastlinkstation == station) {
              return fastLink;
            }
          }
      }
      return undefined;
  }

  TestOffLine():boolean
  {
    if( this.veldStationBluePrint && this.veldStationRunTime) {
      if (this.veldStationBluePrint.status != 0)
        return (this.veldStationRunTime.status == 0) ? true : false;
    }
    return false;
  }

  ngOnInit(): void {
  }

  Unzerobase(val : number  ) : number
  {
    return val+1;
  }
  StationNr(val : number  ) : number
  {
    return (val & 0x7F) -1;
  }

  // Status: [Present,Ready,ToSend,Error;Double,Failure,Shutdown,Last]
  GetStatusString(status: number):string
  {
      var str:string = "";
      str += (status & 0x80) ? "P" : "-";
      str += (status & 0x40) ? "R" : "-";
      str += (status & 0x20) ? "T" : "-";
      str += (status & 0x10) ? "E" : "-";
      str += (status & 0x08) ? "D" : "-";
      str += (status & 0x04) ? "F" : "-";
      str += (status & 0x02) ? "S" : "-";
      str += (status & 0x01) ? "L" : "-";
      return str;
  }
}
